import { rd } from '@passionware/monads';
import { User } from 'lucide-react';
import { useSelector } from 'react-redux';
import { selectAccountsList } from 'store/accounts';
import { EnumFilterDisplayValue } from 'v5/patterns/filters/EnumFilterWidget';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';

/**
 * Shared owner/userId filter configuration factory
 * Can be used in both CallsheetFilter and ProductionFilter
 */
export function createOwnerFilterConfig(): FilterEnumConfig<string> {
  return {
    label: 'Owner',
    icon: <User />,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] }),
    options: {
      useValues: (values: string[]) => {
        const accounts = useSelector(selectAccountsList);
        const activeAccounts = accounts.filter(a => !a.dateArchived);
        const accountDisplayValues: EnumFilterDisplayValue<string>[] =
          activeAccounts.map(account => ({
            value: account.id,
            label:
              account.displayName ||
              `${account.firstName} ${account.lastName}`.trim()
          }));
        return rd.of(
          accountDisplayValues.filter(a => values.includes(a.value))
        );
      },
      useOptions: (query: string) => {
        const accounts = useSelector(selectAccountsList);
        const activeAccounts = accounts.filter(a => !a.dateArchived);
        const accountDisplayValues: EnumFilterDisplayValue<string>[] =
          activeAccounts.map(account => ({
            value: account.id,
            label:
              account.displayName ||
              `${account.firstName} ${account.lastName}`.trim()
          }));
        const normalizedQuery = query.trim().toLowerCase();
        const filtered = accountDisplayValues.filter(a =>
          a.label.toLowerCase().includes(normalizedQuery)
        );
        return rd.of(filtered);
      }
    }
  };
}
